<div class="min-h-screen w-full bg-gradient-to-b from-slate-950 via-slate-950 to-slate-900 text-slate-100">
  <div
    class="pointer-events-none absolute inset-0 opacity-40"
    style="background: radial-gradient(1200px 500px at 50% 0%, rgba(56,189,248,0.15), transparent 60%);"
  ></div>

  <div class="relative px-8 py-6">
    <header class="mb-6 flex flex-wrap items-center justify-between gap-4">
      <div>
        <h1 class="text-2xl font-semibold tracking-wide text-slate-100">{{ title }}</h1>
        <p class="mt-1 text-sm text-slate-400">{{ subtitle }}</p>
      </div>

      <a
        routerLink="/dashboard"
        class="inline-flex h-11 items-center justify-center rounded-xl border border-slate-500/20 bg-slate-900/40 px-4 text-sm font-semibold text-slate-200 transition hover:bg-slate-900/70"
      >
        Volver al dashboard
      </a>
    </header>

    <section class="rounded-2xl border border-slate-500/20 bg-slate-900/55 p-2 shadow-glow">
      <iframe
        [title]="title"
        [src]="iframeUrl"
        class="h-[75vh] w-full rounded-xl border border-slate-500/20 bg-slate-950"
        loading="lazy"
        referrerpolicy="no-referrer"
      ></iframe>
    </section>
  </div>
</div>
